import * as formWizardConstants from './constants';
import 'element-closest-polyfill';

/**
 * Gets the closest FormWizard associated with an element
 *
 * @param {Element} element
 */
export default function getFormWizard(element) {
  if (!element) return;
  return element.closest(formWizardConstants.selectors.wrapper);
}
